<template>
  <v-container v-if="loading">
    <div class="text-xs-center d-flex justify-center align-center">
      <v-progress-circular
          indeterminate
          :size="50"
          :width="3"
          color="primary">
      </v-progress-circular>
    </div>
  </v-container>
  <v-container v-else>
<!--    <div v-if="showInput">-->
<!--&lt;!&ndash;      <input type="hidden" value="0f221182d33804d9c7bb68aa8389fdc7" id="duo-current-hash">&ndash;&gt;-->
<!--&lt;!&ndash;      <input type="hidden" value="25755" id="duo-current-article">&ndash;&gt;-->
<!--&lt;!&ndash;      <input type="hidden" value="644" id="duo-current-article-kind">&ndash;&gt;-->
<!--&lt;!&ndash;      <input type="hidden" value="642" id="duo-current-article-brand">&ndash;&gt;-->
<!--    </div>-->
    <v-row class="text-center">
      <v-col cols="12">
        <div>
          <v-stepper v-model="currentStep" class="v-stepper no-transition">
            <duo-header :steps="steps" :e1="currentStep"></duo-header>
            <duo-stepper :cartItems.sync="duoHeaderCartItems" :steps="steps" :stepPrefix="stepPrefix" :buttons="buttons"
                         @clickednext="nextStep" @clickedprev="prevStep" @clickOnCartAdd="onCartAdd"></duo-stepper>
          </v-stepper>
          <v-btn
              color="primary"
              @click.stop="dialog = true"
              class="clearcache mt-1"
              outlined
              absolute
              top
              left
              small
          >
            <v-icon small>{{ mdiAutorenew }}</v-icon>
            Reset
          </v-btn>

          <v-dialog
              v-model="dialog"
              max-width="290"
              style='z-index:8065;'
          >
            <v-card>
              <v-card-title class="headline">
                Reset configuratie?
              </v-card-title>

              <v-card-text>
                Begin opnieuw met het configureren van uw lade.
              </v-card-text>

              <v-card-actions>
                <v-btn
                    color="secondary"
                    small
                    @click="dialog = false"
                >
                  Nee, ga terug
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    small
                    @click="dialog = false; clearCache()"
                >
                  Ja, begin opnieuw
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-snackbar v-model="snackbar">
            {{ text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                  icon
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar = false">
                <v-icon>far fa-times-circle</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
          <duo-footer :steps="steps" :stepPrefix="stepPrefix" :cartItems.sync="duoHeaderCartItems"></duo-footer>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import globalComponents from '../components/globalComponents'
import globalWatch from '../components/globalWatch'
import globalMethods from '../components/globalMethods'
import {mdiAutorenew} from '@mdi/js';
import axios from 'axios'

export default {
  components: {
    ...globalComponents
  },
  computed: {
    fooparent() {
      return this.duoHeaderCartItems.value;
    }
  },
  watch: {
    ...globalWatch
  },
  methods: {
    ...globalMethods
  },
  data() {
    return {
      mdiAutorenew: mdiAutorenew,
      dialog: false,
      stepPrefix: 'Stap',
      steps: [],
      duoHeaderCartItems: {
        qty: 0,
        value: 0
      },
      loading: true,
      currentStep: 1,
      buttons: {
        prev: 'Vorige',
        next: 'Volgende',
        nextLast: 'Bevestig',
        nextStep: 'Volgende stap',
        completed: 'Voeg toe aan winkelwagen'
      },
      showInput: false,
      snackbar: false,
      text: 'Product is toegevoegd aan de winkelwagen.',
    }
  },
  mounted() {
    //check if serve mode
    if(window.webpackHotUpdate) {
      console.log('serve mode: shop input fields');
      this.showInput = true;
    }
    //run by hash config
    let dochash = '';
    if (document.getElementById('duo-current-hash')) {
      dochash = document.getElementById('duo-current-hash').value;
    }
    const runDocHash = true;
    if (dochash && runDocHash) {
      localStorage.removeItem('steps');
    }

    // get the steps options from external json fil
    axios
        .get('/custom/plugins/KienerDuo/app/dist/static/options-sw.json')
        .then(response => {
          this.steps.push(...response.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error)
        })

    // If it is stored in localStorage then set this var
    // if (localStorage.currentStep) {
    //   this.currentStep = localStorage.currentStep;
    // }
    if (isNaN(this.currentStep)) {
      this.currentStep = 1;
    }
    // if (localStorage.totalprice) {
    //   this.duoHeaderCartItems.value = localStorage.totalprice;
    // }
  }
}
</script>

<style scoped>
.v-stepper {
  box-shadow: none;
}
</style>
